import React from 'react';
import { ShieldCheck, RotateCcw } from 'lucide-react';
import { soundEngine } from '../utils/soundAndSpeech';

interface GuestPracticeGateModalProps {
  onSignUp: () => void;
  onSignIn: () => void;
  onPlayAgain: () => void;
}

export const GuestPracticeGateModal: React.FC<GuestPracticeGateModalProps> = ({
  onSignUp,
  onSignIn,
  onPlayAgain,
}) => {
  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center p-4 bg-black/85 backdrop-blur-md">
      <div className="relative w-full max-w-lg rounded-3xl bg-[#141414] border border-[#262626] p-6 sm:p-8 shadow-2xl text-[#FAFAFA] space-y-6 animate-in fade-in zoom-in-95 duration-200">
        <div className="w-16 h-16 rounded-2xl bg-[#F97316]/15 text-[#F97316] flex items-center justify-center mx-auto border border-[#F97316]/30 shadow-inner">
          <ShieldCheck className="w-8 h-8" />
        </div>

        <div className="text-center space-y-2">
          <h2 className="text-xl sm:text-2xl font-extrabold text-[#FAFAFA] tracking-tight">
            You must be a registered user to show your score results.
          </h2>
          <p className="text-xs sm:text-sm text-[#A3A3A3] leading-relaxed max-w-md mx-auto">
            Create a free Quick!Bible account to unlock your game results, save your progress, earn XP, collect badges, and compete with Bible scholars worldwide.
          </p>
        </div>

        <div className="space-y-3 pt-2">
          <button
            type="button"
            onClick={() => {
              soundEngine.playClick();
              onSignUp();
            }}
            className="w-full h-12 rounded-xl bg-gradient-to-r from-[#FF8A00] to-[#EA580C] hover:brightness-110 text-white font-bold text-sm shadow-lg shadow-orange-950/40 transition-all cursor-pointer flex items-center justify-center"
          >
            Sign Up Now
          </button>
          
          <button
            type="button"
            onClick={() => {
              soundEngine.playClick();
              onSignIn();
            }}
            className="w-full h-12 rounded-xl bg-[#1C1C1C] hover:bg-[#262626] border border-[#404040] text-[#FAFAFA] font-bold text-sm transition-all cursor-pointer flex items-center justify-center"
          >
            Sign In
          </button>

          <button
            type="button"
            onClick={() => {
              soundEngine.playClick();
              onPlayAgain();
            }}
            className="w-full h-11 rounded-xl bg-transparent hover:bg-[#1C1C1C] text-[#A3A3A3] hover:text-[#FAFAFA] font-semibold text-xs transition-all cursor-pointer flex items-center justify-center gap-2"
          >
            <RotateCcw className="w-3.5 h-3.5" />
            <span>Play Again</span>
          </button>
        </div>
      </div>
    </div>
  );
};
